import React from "react";

const Loader = () => {
  return (
    <div className="preloader">
      <div className="lds-hourglass"></div>
    </div>
  );
};

export default Loader;
